<script setup>
import NewsArticleTable from '@frontJs/components/tables/projectManagement/apikom/NewsArticleTable.vue';
import NewsThemeTable from '@frontJs/components/tables/projectManagement/apikom/NewsThemeTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Actualités - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Actualités </PageTitle>

    <TabLayout
        :tabs="{
            newsArticles: {
                title: 'Actualités',
                content: h(NewsArticleTable),
            },
            newsThemes: {
                title: 'Thèmes',
                content: h(NewsThemeTable),
            },
        }"
    />
</template>
